export default __webpack_public_path__ + "static/media/loading-heart.86b737ba.svg";